import PropTypes from 'prop-types';
import HomeIcon from '@mui/icons-material/Home';
import CustomControl from './CustomControl';
import MUITooltip from 'js/components/common/MUITooltip';

const HomeButton = (props) => (
    <CustomControl
        // eslint-disable-next-line
        position={google.maps.ControlPosition.RIGHT_BOTTOM}
    >
        <div className="home-container" data-testid="home-container">
            <div
                className={`home-button ${props.buttonTooltipClass || ''}`}
                onClick={props.onHomeClick}
                data-testid="home-button"
            >
                <MUITooltip
                    title="Home"
                    arrow
                    placement="left"
                >
                    <HomeIcon data-testid="home-icon" />
                </MUITooltip>
            </div>
        </div>
    </CustomControl>
);

HomeButton.propTypes = {
    buttonTooltipClass: PropTypes.string,
    onHomeClick: PropTypes.func,
};

export default HomeButton;
